// src/constants/dataTypes.js

export const deviceTypes = {
  2: 'Electricity meter' ,
  3: 'Gas meter',
  4: 'Heat meter - return flow',
  6: 'Warm water meter',
  7: 'Water meter',
  8: 'Heat Cost Allocator' ,
  10: 'Cooling meter - return flow',
  11: 'Cooling meter - supply flow',
  12: 'Heat meter - supply flow',
  13: 'Combined heat / cooling meter',
  21: 'Hot water meter (>90°C)' ,
  22: 'Cold water meter',
  26: 'Smoke detector',
  27: 'Room sensor',
  55: 'Radio converter meter side'
}



// export const fwdDataTypes = [
//   { value: 'DMReadout', label: 'Meter readout' },
//   { value: 'DMScan', label: 'Meter scan' },
//   { value: 'QnodeReadout', label: 'Network readout' },
//   { value: 'QnodeScan', label: 'Network scan' },
//   { value: 'CustomerReport', label: 'Report' }
// ];
